import { resolveMediaUrl } from './mediaUrl';

const getSection = (page, key) => page?.sections?.find((section) => section.key === key) || null;

const getMediaUrl = (section, groupKey) => {
  const media =
    section?.media?.groups?.[groupKey]?.[0] ||
    (groupKey === 'hero-image' || groupKey === 'feature-image' ? section?.media?.primary : null);

  return media?.url ? resolveMediaUrl(media.url) : '';
};

export const parseInfrastructureHeroContent = (page) => {
  const section = getSection(page, 'hero');
  if (!section) {
    return null;
  }

  const fields = section.fields || {};
  if (!fields.title) {
    return null;
  }

  return {
    eyebrow: fields.eyebrow || '',
    title: fields.title,
    text: fields.text || '',
    cta: {
      text: fields.ctaText || '',
      url: fields.ctaUrl || '/contact',
    },
    image: getMediaUrl(section, 'hero-image'),
  };
};

export const parseInfrastructureProtocolsContent = (page) => {
  const section = getSection(page, 'protocols');
  if (!section) {
    return null;
  }

  const fields = section.fields || {};
  if (!fields.title) {
    return null;
  }

  const paragraphs = [];
  for (let index = 1; index <= 10; index += 1) {
    const value = fields[`paragraph-${index}`];
    if (!value) {
      break;
    }
    paragraphs.push(value);
  }

  return {
    title: fields.title,
    paragraphs,
    image: getMediaUrl(section, 'feature-image'),
  };
};

export const parseInfrastructureOperationalContent = (page) => {
  const section = getSection(page, 'operational');
  if (!section) {
    return null;
  }

  const fields = section.fields || {};
  const items = [];

  for (let index = 1; index <= 10; index += 1) {
    const title = fields[`item-${index}-title`];
    if (!title) {
      break;
    }

    items.push({
      title,
      text: fields[`item-${index}-text`] || '',
      icon: getMediaUrl(section, `item-${index}-icon`),
    });
  }

  if (items.length === 0) {
    return null;
  }

  return {
    title: fields.title || 'Operational Pillars',
    items,
  };
};

export const parseInfrastructureGlobalContent = (page) => {
  const section = getSection(page, 'global');
  if (!section) {
    return null;
  }

  const fields = section.fields || {};
  if (!fields.title) {
    return null;
  }

  return {
    title: fields.title,
    text: fields.text || '',
    image: getMediaUrl(section, 'feature-image'),
  };
};

export const parseInfrastructureNeverStaticContent = (page) => {
  const section = getSection(page, 'never-static');
  if (!section) {
    return null;
  }

  const fields = section.fields || {};
  if (!fields.text) {
    return null;
  }

  return {
    quote: fields.text,
  };
};

export const parseInfrastructureBankOnContent = (page) => {
  const section = getSection(page, 'bank-on');
  if (!section) {
    return null;
  }

  const fields = section.fields || {};
  if (!fields.title) {
    return null;
  }

  return {
    title: fields.title,
    text: fields.text || '',
    cta: {
      text: fields.ctaText || '',
      url: fields.ctaUrl || '/create-account',
    },
  };
};
